export default "__VITE_ASSET__DjMG3Aae__"